import type {QuizSession} from '@cp/model';
import useUserActiveSessions from './useUserActiveSessions';
import useUserCompletedSessions from './useUserCompletedSessions';

export const sessionState = {active: 'active' as const, completed: 'completed' as const};

export interface UseListUserSessionsOptions {
  state: 'active' | 'completed';
  limit?: number;
  offset?: number;
}

export default function useListUserSessions(options: UseListUserSessionsOptions) {
  const {state, limit, offset} = options;
  const active = useUserActiveSessions(state === 'active' ? {limit, offset} : undefined);
  const completed = useUserCompletedSessions(state === 'completed' ? {limit, offset} : undefined);

  if (state === 'active') {
    return {
      sessions: active.sessions as QuizSession[],
      loading: active.loading,
      error: active.error,
      refetch: active.refetch,
    };
  }
  return {
    sessions: completed.sessions as QuizSession[],
    loading: completed.loading,
    error: completed.error,
    refetch: completed.refetch,
  };
}
